module.exports = __webpack_public_path__ + "static/media/baseMeme1.c6a230f6.jpg";